/**
 * Use scopedSlots in Vue 2.6+
 * downgrade to slots in lower version
 */
export default {
  methods: {
    slots: function slots(name, props) {
      if (name === void 0) {
        name = 'default';
      }

      var $slots = this.$slots,
          $scopedSlots = this.$scopedSlots;

      if ($scopedSlots[name]) {
        return $scopedSlots[name](props);
      }

      return $slots[name];
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/mixins/slots.js
// module id = 17
// module chunks = 0 1 2 3 4 5 6 7